import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE, isSupportedLanguage, type Language } from './config';
import { localizePath } from './languagePath';

/** Langue active (toujours une langue supportée) et construction des liens internes. */
export const useLanguage = () => {
    const { i18n } = useTranslation();
    const language: Language = isSupportedLanguage(i18n.resolvedLanguage)
        ? i18n.resolvedLanguage
        : DEFAULT_LANGUAGE;

    return {
        language,
        localize: (path: string) => localizePath(language, path),
    };
};
